// Hell, dunkel oder dem Gerät folgen.
//
// Die Wahl steht im lokalen Speicher des Geräts, nicht im Konto: sie gehört
// zum Bildschirm, an dem jemand sitzt, nicht zur Person. Wer die App auf
// Handy und Rechner benutzt, will dort meist Unterschiedliches.
//
// Gesetzt wird ein Attribut am <html>-Element, auf das die Farbtoken in
// index.css reagieren. Ohne Attribut gilt die Einstellung des Geräts.

const SCHLUESSEL = 'stundenzettel-thema'

export const THEMEN = ['system', 'hell', 'dunkel']

export function holeThema() {
  try {
    const wert = localStorage.getItem(SCHLUESSEL)
    return THEMEN.includes(wert) ? wert : 'system'
  } catch {
    return 'system'
  }
}

export function setzeThema(thema) {
  const gueltig = THEMEN.includes(thema) ? thema : 'system'

  if (gueltig === 'system') delete document.documentElement.dataset.thema
  else document.documentElement.dataset.thema = gueltig

  try {
    if (gueltig === 'system') localStorage.removeItem(SCHLUESSEL)
    else localStorage.setItem(SCHLUESSEL, gueltig)
  } catch {
    // Privater Modus ohne Speicher — dann gilt die Wahl eben nur diesmal.
  }

  faerbeStatusleiste()
  return gueltig
}

// Die Statusleiste des Geräts soll dieselbe Farbe haben wie der
// Seitenhintergrund. Zwei feste Meta-Angaben nach Systemvorliebe reichen dafür
// nicht mehr, sobald jemand ausdrücklich wählt — also hier nachziehen.
export function faerbeStatusleiste() {
  const farbe = getComputedStyle(document.body).backgroundColor
  if (!farbe) return

  for (const alt of document.querySelectorAll('meta[name="theme-color"]')) alt.remove()

  const meta = document.createElement('meta')
  meta.name = 'theme-color'
  meta.content = farbe
  document.head.appendChild(meta)
}
